var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleShipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon--circle-shipping_svg__clip0_1147_5488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48a24 24 0 110-48 24 24 0 010 48zm.632-36.632l-11.18 4.598 4.611 1.895 10.522-4.863-3.953-1.63zm6.77 2.78l-10.99 4.673 4.22 1.743 11.178-4.598-4.42-1.806.012-.013zm5.23 2.829l-11.394 4.686v16.232l11.394-4.623V16.977zm-24 0v16.295l11.393 4.623V21.65l-4.193-1.717v4.699l-2.4-.923v-4.762l-4.8-1.983v.013z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon--circle-shipping_svg__clip0_1147_5488"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon--circle-shipping-52d6cb62353a0c9f74a7408270fcf764.svg";
export { SvgIconCircleShipping as Component };